import { createFileRoute } from "@tanstack/react-router";
import { RevealStagger } from "@/components/site/Reveal";
import { Section } from "@/components/site/Section";
import { useSiteSection } from "@/hooks/useSiteContent";
import { siteImageUrl } from "@/hooks/useSiteData";

export const Route = createFileRoute("/sobre")({
  head: () => ({
    meta: [
      { title: "Sobre a Contato Internet — Conexão de verdade" },
      {
        name: "description",
        content:
          "Conheça a Contato Internet: provedor regional de fibra óptica e rádio, com rede própria, equipe local e milhares de clientes conectados.",
      },
      { property: "og:title", content: "Sobre a Contato Internet" },
      {
        property: "og:description",
        content: "Provedor regional de fibra óptica com rede própria e equipe local.",
      },
    ],
  }),
  component: SobrePage,
});

function SobrePage() {
  const about = useSiteSection("about");
  const foto = siteImageUrl(about.image);
  const paragraphs = (about.text ?? "").split(/\n\s*\n/).filter(Boolean);
  const values = (about.values ?? "")
    .split("\n")
    .map((v) => v.trim())
    .filter(Boolean);

  return (
    <>
      <Section reveal eyebrow="Quem somos" title={about.title}>
        <div
          className={
            foto
              ? "mx-auto grid max-w-5xl items-start gap-8 md:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)]"
              : "mx-auto max-w-4xl"
          }
        >
          {foto && (
            <img
              src={foto}
              alt={about.title}
              loading="lazy"
              className="w-full rounded-3xl border border-border object-cover shadow-sm md:sticky md:top-24"
            />
          )}
          <div className="space-y-4">
            {paragraphs.map((p) => (
              <p
                key={p.slice(0, 40)}
                className="text-sm leading-relaxed text-muted-foreground sm:text-base"
              >
                {p}
              </p>
            ))}
          </div>
        </div>

        <RevealStagger className="mt-12 grid gap-6 md:grid-cols-3" staggerDelay={120}>
          <article className="rounded-3xl border border-border bg-card p-8">
            <h3 className="text-xl">{about.missionTitle}</h3>
            <p className="mt-3 text-sm text-muted-foreground">{about.mission}</p>
          </article>
          <article className="rounded-3xl border border-border bg-card p-8">
            <h3 className="text-xl">{about.visionTitle}</h3>
            <p className="mt-3 text-sm text-muted-foreground">{about.vision}</p>
          </article>
          <article className="rounded-3xl border border-border bg-card p-8">
            <h3 className="text-xl">{about.valuesTitle}</h3>
            <ul className="mt-3 space-y-1.5 text-sm text-muted-foreground">
              {values.map((v) => (
                <li key={v}>• {v}</li>
              ))}
            </ul>
          </article>
        </RevealStagger>
      </Section>
    </>
  );
}
